interface FirefliesLogoProps {
  size?: number;
  className?: string;
}

export function FirefliesLogo({ size = 40, className }: FirefliesLogoProps) {
  return (
    <div
      className={`flex items-center justify-center rounded-md bg-gradient-to-b from-[#140F37] to-[#140F37] ${className}`}
      style={{
        width: size,
        height: size,
        padding: "10px",
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.50758 0H0.000976562V6.46107H6.50758V0Z"
          fill="url(#paint0_linear_49851_66179)"
        />
        <path
          d="M14.2181 7.80029H7.70947V14.2604H14.2181V7.80029Z"
          fill="url(#paint1_linear_49851_66179)"
        />
        <path
          d="M14.2181 6.14412e-07H7.70947V6.46107H19.7981V5.5375C19.7978 4.80916 19.6533 4.0881 19.3728 3.41596C19.0923 2.74381 18.6814 2.1339 18.1638 1.62146C17.1141 0.582064 15.6953 -0.000690724 14.2181 6.14412e-07Z"
          fill="url(#paint2_linear_49851_66179)"
        />
        <path
          d="M0 7.80029V14.2604C0 15.7294 0.588 17.138 1.63333 18.1764C2.68356 19.2163 4.10212 19.7991 5.58006 19.7979H6.50958V7.80029H0Z"
          fill="url(#paint3_linear_49851_66179)"
        />
        <path
          opacity="0.18"
          d="M0 0L6.5076 6.46107H0V0Z"
          fill="url(#paint4_linear_49851_66179)"
        />
        <path
          opacity="0.18"
          d="M7.70947 7.80029L14.2181 14.2604H7.70947V7.80029Z"
          fill="url(#paint5_linear_49851_66179)"
        />
        <path
          opacity="0.18"
          d="M0 14.2604C0 15.7294 0.588 17.138 1.63333 18.1764C2.68356 19.2163 4.10212 19.7991 5.58006 19.7979H6.50958V7.80029L0 14.2604Z"
          fill="url(#paint6_linear_49851_66179)"
        />
        <path
          opacity="0.18"
          d="M14.219 0C15.6979 0 17.1174 0.58404 18.1638 1.62145C18.6811 2.13398 19.0919 2.74393 19.3722 3.41607C19.6525 4.08821 19.797 4.80923 19.7971 5.53749V6.46107H7.71143L14.219 0Z"
          fill="url(#paint7_linear_49851_66179)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_49851_66179"
            x1="15.9195"
            y1="16.3452"
            x2="-11.4393"
            y2="-12.3995"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E82A73" />
            <stop offset="0.113" stopColor="#DE2D7A" />
            <stop offset="0.3" stopColor="#C5388F" />
            <stop offset="0.54" stopColor="#9B4AB0" />
            <stop offset="0.818" stopColor="#6262DE" />
            <stop offset="0.994" stopColor="#3B73FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_49851_66179"
            x1="16.0147"
            y1="16.257"
            x2="-11.3441"
            y2="-12.4887"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF3C82" />
            <stop offset="0.103" stopColor="#F53E88" />
            <stop offset="0.274" stopColor="#DC4598" />
            <stop offset="0.492" stopColor="#B251B2" />
            <stop offset="0.745" stopColor="#7961D7" />
            <stop offset="0.994" stopColor="#3B73FF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_49851_66179"
            x1="20.5593"
            y1="11.9332"
            x2="11.2889"
            y2="-21.661"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E82A73" />
            <stop offset="0.113" stopColor="#DE2D7A" />
            <stop offset="0.3" stopColor="#C5388F" />
            <stop offset="0.54" stopColor="#9B4AB0" />
            <stop offset="0.818" stopColor="#6262DE" />
            <stop offset="0.994" stopColor="#3B73FF" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_49851_66179"
            x1="11.4353"
            y1="20.6135"
            x2="-21.7511"
            y2="10.5037"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E82A73" />
            <stop offset="0.113" stopColor="#DE2D7A" />
            <stop offset="0.3" stopColor="#C5388F" />
            <stop offset="0.54" stopColor="#9B4AB0" />
            <stop offset="0.818" stopColor="#6262DE" />
            <stop offset="0.994" stopColor="#3B73FF" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_49851_66179"
            x1="-3.18253"
            y1="-8.06966"
            x2="6.11263"
            y2="13.23"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E82A73" />
            <stop offset="0.114" stopColor="#DE286E" />
            <stop offset="0.303" stopColor="#C52361" />
            <stop offset="0.544" stopColor="#9B1A4D" />
            <stop offset="0.825" stopColor="#620F30" />
            <stop offset="0.994" stopColor="#3D081E" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_49851_66179"
            x1="4.52695"
            y1="-0.270354"
            x2="13.8221"
            y2="21.0303"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E82A73" />
            <stop offset="0.114" stopColor="#DE286E" />
            <stop offset="0.303" stopColor="#C52361" />
            <stop offset="0.544" stopColor="#9B1A4D" />
            <stop offset="0.825" stopColor="#620F30" />
            <stop offset="0.994" stopColor="#3D081E" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_49851_66179"
            x1="-2.16095"
            y1="-0.610879"
            x2="18.8912"
            y2="13.3744"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E82A73" />
            <stop offset="0.114" stopColor="#DE286E" />
            <stop offset="0.303" stopColor="#C52361" />
            <stop offset="0.544" stopColor="#9B1A4D" />
            <stop offset="0.825" stopColor="#620F30" />
            <stop offset="0.994" stopColor="#3D081E" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_49851_66179"
            x1="-460.852"
            y1="454.534"
            x2="-457.245"
            y2="483.015"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E82A73" />
            <stop offset="0.114" stopColor="#DE286E" />
            <stop offset="0.303" stopColor="#C52361" />
            <stop offset="0.544" stopColor="#9B1A4D" />
            <stop offset="0.825" stopColor="#620F30" />
            <stop offset="0.994" stopColor="#3D081E" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
